/* eslint-disable */

/*!
 * Finnish Hyhpenator
 *
 * Tavuttajan tavoite on helppokayttoinen ja kevyt selainpuolen
 * tekstien tavutus. Scriptin tarkoitus ei ole olla taydellinen
 * tavuttaja, vaan tavuttaa varmimmat tapaukset. Mielummin
 * tavuttaja jattaa tavuttamatta kuin tavuttaa epavarman paikan.
 *
 *
 * Hyphenation rules:
 *
 * [1] Tavuraja on aina konsonantin ja vokaalin yhdistelman edella
 * http://www.kotus.fi/index.phtml?s=4363, Hakupaiva 10.6.2014
 *
 *
 * - Alle kahden merkin tavuja ei tehda
 *
 * Author: Veikko Karsikko
 */
(function(window) {
  /**
   * Constructor
   */
  function FinnishHyphenator() {
    this.vowels = 'aeiouyåäö';
    this.consonants = 'bcdfghjklmnpqrstvwxyz';
    this.hyphMark = '\u00AD';
    this.minWordLength = 12; // Added by Evermade
    this.minDistance = 6; // Added by EVermade
    // construct regExps only once
    this.rule1RegExp = new RegExp(
      '[' + this.consonants + '][' + this.vowels + ']',
      'gi',
    );
    this.endReg = new RegExp(
      '[' + this.consonants + this.vowels + ']{2}$',
      'i',
    );
    this.wrapperElement = document.createElement('div');
  }

  /**
   * Adds hyphen to text if first part matches endReg
   */
  FinnishHyphenator.prototype.addHyphen = function(text, idx) {
    var firstPart = text.slice(0, idx);
    var match = this.endReg.exec(firstPart);

    if (
      match &&
      match.index > this.minDistance &&
      match.index + match[0].length < text.length - this.minDistance
    ) {
      return text.slice(0, idx) + this.hyphMark + text.slice(idx);
    } else {
      return false;
    }
  };

  /**
   * Hyphenates JQuery element contents
   */
  FinnishHyphenator.prototype.hyphenateElement = function(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3) {
        // is text element and will be hyphenated
        //node.data = this.hyphenateText(node.textContent);

        // Let's instead break it into words and hyphenate each separately – Added by Evermade
        var words = node.textContent.match(/\S+\s*/g);

        if (words) {
          for (var j = 0; j < words.length; j++) {
            if (words[j].length >= this.minWordLength) {
              words[j] = this.hyphenateText(words[j]);
            }
          }

          node.data = words.join('');
        }
      } else {
        this.hyphenateElement(node);
      }
    }
  };

  FinnishHyphenator.prototype.hyphenateElements = function(els) {
    for (var i = 0; i < els.length; i++) {
      this.hyphenateElement(els[i]);
    }
  };

  /**
   * Hyphenates text block
   */
  FinnishHyphenator.prototype.hyphenateText = function(text) {
    var hyphenated = text;
    var hyphPositions = [];

    // rule [1]
    var match;
    while ((match = this.rule1RegExp.exec(text)) !== null) {
      hyphPositions.push(match.index);
    }

    var count = 0;
    for (var i = 0; i < hyphPositions.length; i++) {
      var position = hyphPositions[i] + count * this.hyphMark.length;
      var triedHyphenation = this.addHyphen(hyphenated, position);
      if (triedHyphenation !== false) {
        count++;
        hyphenated = triedHyphenation;
      }
    }
    return hyphenated;
  };

  window.FinnishHyphenator = FinnishHyphenator;
})(window);

const initHyphenate = () => {
  const finHyph = new FinnishHyphenator();
  const hyphElements = document.querySelectorAll('.site-content h1, .site-content h2, .site-content h3, .site-content h4, .site-content h5 .icons-block__icon__title__text');

  finHyph.hyphenateElements(hyphElements);
};

document.addEventListener('DOMContentLoaded', initHyphenate);
document.addEventListener('GrowthstackABTestReplacementAfter', initHyphenate);

